export const definedfiEndpoint = 'https://graph.defined.fi/graphql'